import React from 'react';

export default function MapSection() {
  return (
    <section className="w-full h-[450px]">
      <iframe
        title="YTeams"
        src="https://www.google.com/maps/place/YTeams+Private+Limited/@31.4834177,74.3966944,19.93z/data=!4m6!3m5!1s0x391905420adba231:0xefc8b842790b6c9f!8m2!3d31.4833597!4d74.3968658!16s%2Fg%2F11rnqyz1_7?entry=ttu&g_ep=EgoyMDI1MDkyOS4wIKXMDSoASAFQAw%3D%3D"
        width="100%"
        height="100%"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="border-0 w-full h-full"
      ></iframe>
    </section>
  );
}
